<template>
	<div
		class="btn navbar-toggler-humburger-icon navbar-toggler me-1 me-sm-3 collapsed"
		type="button"
		data-bs-toggle="collapse"
		data-bs-target="#navbarStandard"
		aria-controls="navbarStandard"
		aria-expanded="false"
		aria-label="Toggle Navigation"
	>
		<button class="btn navbar-toggler-humburger-icon">
			<span class="navbar-toggle-icon"><span class="toggle-line"></span></span>
		</button>
	</div>
</template>
